import {
    Box,
    Button,
    Center,
    Flex,
    Heading,
    IconButton,
    Popover,
    PopoverBody,
    PopoverContent,
    PopoverHeader,
    PopoverTrigger,
    Spacer,
    Tag,
    TagLabel,
    Tooltip,
    useColorMode,
} from '@chakra-ui/react';
import { useKeycloak } from '@react-keycloak/web';
import { FaBell, FaQuestionCircle, FaUser } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import config from '../config';
import { useLocalStorage } from '../hooks/useLocalStorage';
import { getEnvironmentLabel } from '../util/util';
import { Logo } from './Logo';

export const Navbar: React.FC<{}> = () => {
    const { keycloak, initialized } = useKeycloak();
    const [notificationCount, setNotificationCount] = useLocalStorage('notification-count', 1);
    const { colorMode, toggleColorMode } = useColorMode();
    const envLabel = getEnvironmentLabel();

    return (
        <Box as="nav" padding={5} width="100%" backgroundColor="#9a9a9a">
            <Flex alignItems="center">
                <Link to="/">
                    <Flex>
                        <Logo variant={colorMode} />
                        <Center>
                            <Heading>Developer Portal</Heading>
                        </Center>
                    </Flex>
                </Link>
                {envLabel !== 'prod' && (
                    <Tag marginLeft={'1em'}>
                        <TagLabel fontWeight={'bold'} textTransform={'uppercase'}>
                            {envLabel}
                        </TagLabel>
                    </Tag>
                )}
                <Spacer />
                {/* TODO: Fully implement color mode configuration before enabling this */}
                {/* <Box padding={1.5}>
                    <Tooltip label="Switch Color Mode">
                        <Box position="relative">
                            <IconButton onClick={toggleColorMode} aria-label="Switch Color Mode" icon={colorMode == "light" ? <FaSun/> : <FaMoon/>} />
                        </Box>
                    </Tooltip>
                </Box> */}
                <Box padding={1.5}>
                    <Popover>
                        <Tooltip label="Notifications">
                            <Box position="relative">
                                <PopoverTrigger>
                                    <IconButton
                                        onClick={() => setNotificationCount(0)}
                                        aria-label="Notifications"
                                        icon={<FaBell />}
                                    />
                                </PopoverTrigger>
                                {notificationCount > 0 && (
                                    <Tag
                                        position="absolute"
                                        right="-10px"
                                        top="-8px"
                                        size="sm"
                                        borderRadius="full"
                                        variant="solid"
                                        colorScheme="red"
                                    >
                                        <TagLabel>{notificationCount}</TagLabel>
                                    </Tag>
                                )}
                            </Box>
                        </Tooltip>
                        <PopoverContent>
                            <PopoverHeader>Welcome to STREAMSIX Developer Portal!</PopoverHeader>
                            <PopoverBody>
                                Thanks for joining us. We are looking forward to seeing the fun and
                                exciting games you create for the STREAMSIX platform!
                            </PopoverBody>
                        </PopoverContent>
                    </Popover>
                </Box>
                <Box padding={1.5}>
                    <Popover>
                        <Tooltip label="Help and Support">
                            <Box position="relative">
                                <PopoverTrigger>
                                    <IconButton
                                        aria-label="Help and Support"
                                        icon={<FaQuestionCircle />}
                                    />
                                </PopoverTrigger>
                            </Box>
                        </Tooltip>
                        <PopoverContent>
                            <PopoverBody as={Flex} flexDirection="column">
                                <Button as="a" href={config.docsURL} target="_blank" margin={1}>
                                    SDK &amp; API Docs
                                </Button>
                                <Button
                                    as="a"
                                    href="https://discord.com/channels/900077168393072660/905668742397186109"
                                    target="_blank"
                                    margin={1}
                                >
                                    Support
                                </Button>
                                <p style={{ textAlign: 'center' }}>
                                    Dev Portal version: {process.env.VERSION} ({process.env.COMMIT})
                                </p>
                            </PopoverBody>
                        </PopoverContent>
                    </Popover>
                </Box>
                <Box padding={1.5}>
                    <Popover>
                        <Tooltip label="Profile">
                            <Box position="relative">
                                <PopoverTrigger>
                                    <IconButton aria-label="Profile" icon={<FaUser />} />
                                </PopoverTrigger>
                            </Box>
                        </Tooltip>
                        <PopoverContent>
                            <PopoverBody as={Flex} flexDirection="column">
                                <Button
                                    as="a"
                                    href="#"
                                    onClick={() => initialized && keycloak.accountManagement()}
                                    margin={1}
                                >
                                    Settings
                                </Button>
                                <Button
                                    as="a"
                                    href="#"
                                    onClick={() => initialized && keycloak.logout()}
                                    margin={1}
                                >
                                    Logout
                                </Button>
                            </PopoverBody>
                        </PopoverContent>
                    </Popover>
                </Box>
            </Flex>
        </Box>
    );
};
